import { t } from "i18next";
import { useRef, useEffect } from "react";
import { EventTypes } from "../../../screens/root/api/eventsApi";
import { FunnelComponentProps } from "../../funnel/types";
import { FUNNEL_TYPES } from "../../funnel/utils/contants";
import { AuthFunnelContent } from "./AuthFunnelContent";

export function AuthFunnel({
  activeAuthType,
  setFunnelType,
  onClose,
  updateFunnelConfig,
  onSuccess,
  sendEvent,
  ...props
}: FunnelComponentProps & {
  setFunnelType: (type: FUNNEL_TYPES) => void;
  activeAuthType?: FUNNEL_TYPES;
  waiting?: boolean;
  centerWelcomeText?: boolean;
  showEmailPasswordForm?: boolean;
  largeLoginCTA?: boolean;
}) {
  const authProps = {
    setFunnelType,
    onClose,
    onSuccess,
    updateFunnelConfig,
  };

  const alreadyTracked = useRef(false);

  useEffect(() => {
    if (sendEvent && !alreadyTracked.current) {
      sendEvent(EventTypes.viewed_registration);
      alreadyTracked.current = true;
    }
  }, []);

  return (
    <AuthFunnelContent
      activeType={activeAuthType}
      funnelProps={authProps}
      loadingText={t("components.payments.subscription.purchasing")}
      welcomeText={t("components.payments.subscription.almostThereSignUp")}
      loginWelcomeText={t("components.payments.subscription.almostThereLogin")}
      {...props}
    />
  );
}
